import React from 'react';
import { useLanguage } from '../../features/language/useLanguage';

export const BatchList: React.FC = () => {
  const { t } = useLanguage();
  return (
    <div>{t('batch.list.placeholder')}</div>
  );
};
